import { useEmployeeAvatar } from '../../utils/employeeAvatar';
import Avatar from '@mui/joy/Avatar';
import Box from '@mui/joy/Box';

import { avatarGradient, initialsOf, CHAT } from './chatTheme';

/**
 * Аватар с инициалами и цветом, выведенным из имени.
 *
 * Раньше это был пустой серый кружок у всех подряд — в списке из тысячи
 * чатов их невозможно было различить глазом. Теперь цвет стабильно привязан
 * к имени: один и тот же человек везде одного цвета.
 */
export default function AvatarWithStatus({
  online = false,
  showStatus = false,
  name,
  alt,
  size = 'md',
  src,
  person,
  sx,
  ...other
}) {
  const label = name || alt || '';
  const photo = useEmployeeAvatar(person, src);
  const px = size === 'sm' ? CHAT.avatarSm : size === 'lg' ? CHAT.avatarLg : CHAT.avatarMd;

  const avatar = (
    <Avatar
      src={photo}
      alt={label}
      {...other}
      sx={{
        width: px,
        height: px,
        fontWeight: 700,
        fontSize: px <= 34 ? 13 : px >= 72 ? 30 : 15,
        color: '#fff',
        letterSpacing: '0.02em',
        background: avatarGradient(label),
        borderRadius: '50%',
        flexShrink: 0,
        ...sx,
      }}
    >
      {initialsOf(label)}
    </Avatar>
  );

  if (!showStatus) return avatar;

  // Точка «в сети». Раньше она означала живой веб-сокет — то есть состояние
  // НАШЕЙ связи, — а читали её как статус собеседника, потому что именно это
  // она значит в любом мессенджере. Теперь значение совпало с привычкой:
  // зелёная — человек онлайн, серая — нет.
  const dot = Math.max(9, Math.round(px * 0.26));

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', flexShrink: 0 }}>
      {avatar}
      <Box
        sx={{
          position: 'absolute',
          right: -1,
          bottom: -1,
          width: dot,
          height: dot,
          borderRadius: '50%',
          backgroundColor: online ? '#22c55e' : '#94a3b8',
          border: '2px solid var(--joy-palette-background-surface, #fff)',
          boxShadow: online ? '0 0 0 0 rgba(34,197,94,0.55)' : 'none',
          animation: online ? 'chatPulse 1.9s ease-out infinite' : 'none',
          '@keyframes chatPulse': {
            '0%':   { boxShadow: '0 0 0 0 rgba(34,197,94,0.55)' },
            '70%':  { boxShadow: '0 0 0 7px rgba(34,197,94,0)' },
            '100%': { boxShadow: '0 0 0 0 rgba(34,197,94,0)' },
          },
        }}
      />
    </Box>
  );
}
